module.exports = __webpack_public_path__ + "img/BBB_accredited_business_logo.bb67d84f.svg";